// const BASE_URL = `${window.location.protocol}//${window.location.hostname}/Machine/backend`;
const BASE_URL = `https://embroiderybazar.in/backend`;
export const API = {
  /* ================= AUTH ================= */
  REGISTER: `${BASE_URL}/api.php?action=register`,
  LOGIN: `${BASE_URL}/api.php?action=login`,
  LOGOUT: `${BASE_URL}/api.php?action=logout`,
  COUNTS1: `${BASE_URL}/api.php?get_counts`,
  /* ================= DESIGN ================= */
  ADD_ADS_PLAN: `${BASE_URL}/api.php?action=add_ads_plan`,
  DELETE_ADS_PLAN: `${BASE_URL}/api.php?action=delete_ads_plan`,
  UPDATE_ADS_PLAN: `${BASE_URL}/api.php?action=update_ads_plan`,
  GET_ADS_PLANS: `${BASE_URL}/api.php?action=get_ads_plans`,
  LIST_ALL_DESIGNS: `${BASE_URL}/api.php?action=list_designs`,
  LIST_DESIGNS: `${BASE_URL}/api.php?action=list_designs_limit`,
  ADD_DESIGN: `${BASE_URL}/api.php?action=add_design`,
  DELETE_DESIGN: `${BASE_URL}/api.php?action=delete_design`,
  UPDATE_DESIGN: `${BASE_URL}/api.php?action=update_design`,
  ADD_CONCEPT: `${BASE_URL}/api.php?action=add_concept`,
  CONCEPT_LIST: `${BASE_URL}/api.php?action=list_concepts`,
  DELETE_CONCEPT: `${BASE_URL}/api.php?action=delete_concept`,
  UPDATE_CONCEPT: `${BASE_URL}/api.php?action=update_concept`,
  /* ================= DESIGNER ================= */

  ADD_DESIGNER: `${BASE_URL}/api.php?action=add`,
  LIST_PENDING: `${BASE_URL}/api.php?action=list_pending`,
  LIST_ACTIVE_DESIGNERS: `${BASE_URL}/api.php?action=list_active`,
  UPDATE_DESIGNER_STATUS: `${BASE_URL}/api.php?action=update_status`,
  DELETE_DESIGNER: `${BASE_URL}/api.php?action=delete`,
  GET_SINGLE_DESIGNER: `${BASE_URL}/api.php?action=get_single`,
  USER_DESIGNERS: `${BASE_URL}/api.php?action=user_designers`,
  UPDATE_DESIGNERS: `${BASE_URL}/api.php?action=update_profile`,
  RENEW_ADS: `${BASE_URL}/api.php?action=renew_ads`,
  /* ================= WORKSPACE ================= */

  ADD_WORKSPACE: `${BASE_URL}/api.php?action=add_workspace`,
  UPDATE_WORKSPACE: `${BASE_URL}/api.php?action=update_workspace`,
  LIST_PENDING_WORKSPACES: `${BASE_URL}/api.php?action=list_workspaces&status=Pending`,
  LIST_ACTIVE_WORKSPACES: `${BASE_URL}/api.php?action=list_workspaces&status=Active`,
  UPDATE_WORKSPACE_STATUS: `${BASE_URL}/api.php?action=workspace_status`,
  DELETE_WORKSPACE: `${BASE_URL}/api.php?action=delete_workspace`,
  LIST_WORKSPACES: `${BASE_URL}/api.php?action=list_workspaces`,
  LIST_HIDE_WORKSPACES: `${BASE_URL}/api.php?action=list_workspaces&status=Hidden`,

  /* ================= MACHINE ================= */

  ADD_MACHINE: `${BASE_URL}/api.php?action=add_machine`,
  UPDATE_MACHINE: `${BASE_URL}/api.php?action=update_machine`,
  LIST_MACHINES: `${BASE_URL}/api.php?action=list_machines`,
  LIST_ACTIVE_MACHINES: `${BASE_URL}/api.php?action=list_machines&status=Active`,
  LIST_PENDING_MACHINES: `${BASE_URL}/api.php?action=list_machines&status=Pending`,
  UPDATE_MACHINE_STATUS: `${BASE_URL}/api.php?action=update_machine_status`,
  DELETE_MACHINE: `${BASE_URL}/api.php?action=delete_machine`,
  LIST_HIDE_MACHINES: `${BASE_URL}/api.php?action=list_machines&status=Hide`,

  /* ================= USERS ================= */

  LIST_USERS: `${BASE_URL}/api.php?action=list`,
  USER_DETAILS: `${BASE_URL}/api.php?action=user_details`,
  // GET_USER: `${BASE_URL}/api.php?action=get_user`,
  BLOCK_USER: `${BASE_URL}/api.php?action=block`,
  UNBLOCK_USER: `${BASE_URL}/api.php?action=unblock`,
  // config/api.js
  GET_USER: `${BASE_URL}/api.php?action=getuser&id=`, // ✅ Note the trailing id=
  // Make sure PROFILE has correct format:

  /* ================= PROFILE ================= */

  // Make sure PROFILE has correct format:
  PROFILE: `${BASE_URL}/api.php?action=profile`,
  UPDATE_PROFILE: `${BASE_URL}/api.php?action=update`,
  UPDATE_PASSWORD: `${BASE_URL}/api.php?action=update_password`,

  /* ================= PASSWORD ================= */

  CHANGE_PASSWORD: `${BASE_URL}/api.php?action=password`,
  FORGOT_PASSWORD: `${BASE_URL}/api.php?action=forgot_password`,
  VERIFY_OTP: `${BASE_URL}/api.php?action=verify_otp`,
  RESET_PASSWORD: `${BASE_URL}/api.php?action=reset_password`,

  /* ================= ORDERS ================= */

  ALL_ORDERS: `${BASE_URL}/api.php?action=all_orders`,
  LIST_USER_ORDERS: `${BASE_URL}/api.php?action=list_user_orders`,
  UPDATE_ORDER_STATUS: `${BASE_URL}/api.php?action=update_order_status`,
  PLACE_ORDER: `${BASE_URL}/api.php?action=place_order`,
  /* ================= SEARCH ================= */

  SEARCH: `${BASE_URL}/api.php?action=search`,

  /* ================= CONTACT ================= */

  CONTACT: `${BASE_URL}/api.php?action=list_contact`,

  /* ================= DASHBOARD ================= */

  ADMIN_DASHBOARD: `${BASE_URL}/api.php?action=admin_dashboard`,
  /* ================= USER DASHBOARD ================= */

  USER_DASHBOARD: `${BASE_URL}/api.php?action=user_dashboard`,
};

export const UPLOADS = {
  DESIGN_IMAGE: `${BASE_URL}/uploads/designs/`,
  WORKSPACE_IMAGE: `${BASE_URL}/uploads/`,
  MACHINE_IMAGE: `${BASE_URL}/uploads/`,
  PROFILE_IMAGE: `${BASE_URL}/uploads/`,
  DESIGNER_IMAGE: `${BASE_URL}/uploads/`,
  DESIGN_FILE: `${BASE_URL}/uploads/designs/`,
  DESIGN_EMB: `${BASE_URL}/uploads/designs/`,
  PAYMENT_SCREENSHOT: `${BASE_URL}/uploads/`,
};
